import DiallerCallActionButton from './DiallerCallActionButton.component';

export * from './DiallerCallActionButton.component';
export default DiallerCallActionButton;